import styled from '@emotion/styled';

export const Avatar = styled.img`
  height: ${({ size }: { size: number }) => `${size}px`};
  border-radius: 50%;
  cursor: pointer;
`;
